import { combineReducers } from 'redux';
import * as actionTypes from '../action-mgr/actionTypes';

const selectedDownloadDataStation = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_DOWNLOAD_DATA_STATION:
      return action.stationName;
    case actionTypes.RESET_DOWNLOAD_DATA_STATION:
      return action.data;
    default:
      return state;
  }
}

const currentDownloadDataStation = (state = "", action) => {
  switch (action.type) {
    case actionTypes.CURRENT_DOWNLOAD_DATA_STATION:
      return action.stationName;
    default:
      return state;
  }
}

const downloadDataCheckObject = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.CHECK_DOWNLOAD_DATA_OBJECT:
      return {
        ...state,
        downloadDataStationYear: action.data ? action.data.year : undefined,
        downloadDataStationMonth: action.data ? action.data.month : undefined,

      };
    default:
      return state;
  }
};

const downloadDataListObject = (state = [], action) => {
  switch (action.type) {
    case actionTypes.LIST_DOWNLOAD_DATA_OBJECT:
      return {
        ...state,
        downloadDataList: action.data.station, 
      };
    default:
      return state;
  }
};

const selectedMonth = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_DOWNLOAD_DATA_MONTH:
      return action.month;
    default:
      return state;
  }
}

const selectedYear = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_DOWNLOAD_DATA_YEAR:
      return action.year;
    default:
      return state;
  }
}


export const clearSelectedFiles = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.CLEAR_SELECTED_FILES:
      return {
        ...state,
        checkedItems: {}, // Clear selected files
      };
    default:
      return state;
  }
};


export default combineReducers({
  selectedDownloadDataStation,
  currentDownloadDataStation,
  downloadDataCheckObject,  
  downloadDataListObject,
  selectedYear,
  selectedMonth,
  clearSelectedFiles
});

const getCurrentState = state => state.downloadRequests.downloadData;

export const getSelectedStationName = state => getCurrentState(state).selectedDownloadDataStation;
export const getCurrentDownloadDataStation = state => getCurrentState(state).currentDownloadDataStation;

export const getDownloadDataCheck = state => getCurrentState(state).downloadDataCheckObject;
export const listDownloadDataObject = state => getCurrentState(state).downloadDataListObject;

export const getSelectedYear = state => getCurrentState(state).selectedYear;
export const getSelectedMonth = state => getCurrentState(state).selectedMonth;

export const getSelectedFiles = state => getCurrentState(state).clearSelectedFiles;
